import React, { FC, memo } from 'react';
import {
    Wrapper,
    Title,
    Content,
    ItemWrapper,
    Item,
    ScoreWrapper,
    Score,
    ScoreText,
} from './components';
import { Col, Row } from 'udesk-ui';

interface TemplateProps {
    latestData?: any;
}

const Template: FC<TemplateProps> = memo((props) => {
    const { latestData } = props;

    return (
        <Wrapper>
            <Title>{latestData?.taskName || '-'}</Title>

            <Content>
                <Row>
                    <Col span={18}>
                        <ItemWrapper>
                            <Item>
                                <span>联系电话：</span>
                                <span>{latestData?.phoneNumber || '-'}</span>
                            </Item>

                            <Item>
                                <span>拨出时间：</span>
                                <span>{latestData?.createdTime || '-'}</span>
                            </Item>
                        </ItemWrapper>
                    </Col>

                    <Col span={6}>
                        <ScoreWrapper>
                            <Score>{latestData?.score ?? 0}</Score>
                            <ScoreText>得分详情/分</ScoreText>
                        </ScoreWrapper>
                    </Col>
                </Row>
            </Content>
        </Wrapper>
    );
});

export default Template;
